import { render, staticRenderFns } from "./SaleFileForm.vue?vue&type=template&id=4af7135a"
import script from "./SaleFileForm.vue?vue&type=script&lang=js"
export * from "./SaleFileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports